// Secciones del menú principal que habilitan los permisos de la sesión, en orden de
// prioridad. Es la única fuente de verdad: el menú de App.vue y el destino al que se
// entra después del ingreso salen de esta misma lista, así que nunca se envía al
// usuario a una vista que su propio menú no le ofrece.
export function routesForPermissions(permissions) {
    var routes = [];

    //Si no ha iniciado sesión se muestran las rutas básicas
    if (!permissions) {
        routes.push({name: 'Inicio', path: '/inicio'});
        return routes;
    }

    if (permissions.visor) {
        routes.push({name: 'Visor', path: '/visor'});
    }
    // Los Instructivos (wiki) son transversales: toda sesión autenticada puede consultarlos.
    routes.push({name: 'Instructivos', path: '/wiki'});
    // Resumen oculto temporalmente del menú principal.
    // routes.push({name:'Resumen' , path: '/dashboard'});
    if (permissions.maps) {
        routes.push({name: 'Mapas', path: '/mapas'});
    }
    if (permissions.layers) {
        routes.push({name: 'Capas', path: '/capas'});
    }
    // OCULTAR GEOPROCESOS DEL MENÚ PRINCIPAL
    // if(permissions.geo) {
    //   routes.push({name:'Geoprocesos' , path: '/geoprocesos'});
    // }
    if (permissions.users) {
        routes.push({name: 'Usuarios', path: '/usuarios'});
    }
    if (permissions.monitoring) {
        routes.push({name: 'Monitoreo', path: '/monitoreo'});
    }
    if (permissions.documents) {
        routes.push({name: 'Documentos', path: '/documentos'});
    }
    var terrain = permissions.terrain;
    if (terrain && (terrain.manage || terrain.respond || terrain.review || terrain.publish)) {
        if (terrain.review && !terrain.manage) {
            routes.push({name: 'Terreno', path: '/terreno/revision', activeMatch: '/terreno'});
        } else {
            routes.push({name: 'Terreno', path: '/terreno/campanas', activeMatch: '/terreno'});
        }
    }

    return routes;
}

// Destino al que se entra después del ingreso: la primera sección disponible.
// Devuelve null cuando la sesión no habilita ninguna, para no mandar al usuario a
// una vista que lo va a rebotar a "página no encontrada".
export function landingRouteForPermissions(permissions) {
    if (!permissions) {
        return null;
    }
    var routes = routesForPermissions(permissions);
    return routes.length ? routes[0].path : null;
}

// Redirección que corresponde cuando la sesión no habilita una sección, o null
// cuando sí la habilita.
//
// El menú ya no ofrece lo que la sesión no puede ver, pero escribir la URL a
// mano igual entra: el backend responde 401 por falta de permiso y el
// interceptor global de main.js solo reacciona al 403 de sesión inválida, así
// que ese 401 deja al usuario dentro de la vista mirando un error.
//
// Se usa desde los beforeEnter de router.js. Vive acá porque este archivo ya es
// la fuente de verdad de qué permiso habilita qué sección.
export function guardRedirect(permissions, requiredPermission) {
    if (permissions && permissions[requiredPermission]) {
        return null;
    }
    return { name: 'not-found' };
}
